import localFont from 'next/font/local';

export const AlphaLyraeFont = localFont({
  src: [{ path: './alphalyrae-medium.woff2', weight: '500' }],
});

export const AlphaLyrae = AlphaLyraeFont.style.fontFamily;
